import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const AffiliateDisclaimer = () => {
  return (
    <div>
      <Navbar />
      <div className="flex flex-col md:flex-row justify-between gap-6 px-6 py-8 bg-gray-50">
        {/* Disclaimer Section */}
        <div className="flex-[2] bg-white shadow-md p-6 rounded-lg">
          <h2 className="text-2xl font-bold mb-4">Affiliate Disclaimer</h2>

          <p className="text-gray-700 mb-4">
            Our website may contain affiliate links, which means we may receive
            a commission if you click a link and purchase something that we have
            recommended. While clicking these links won’t cost you any extra
            money, they will help us keep this site up and running. We only
            recommend products and services we truly believe in and have used
            ourselves. Thank you for your support!”
          </p>
        </div>

        {/* About Me Section */}
        <div className="flex-[1] bg-white shadow-md p-6 rounded-lg max-w-sm">
          <div className="flex flex-col items-center text-center">
            <img
              src="/Assets/man.webp" // Replace with your actual image URL
              alt="About Me"
              className="w-32 h-32 rounded-full mb-4"
            />
            <h3 className="text-lg font-bold">About Me</h3>
            <p className="text-gray-700 mt-2">
              Welcome to solarissurge.net! I'm the driving force behind this
              site, which attracts over 1,000 daily visitors interested in solar
              energy. I'm also the author of a popular solar energy book, with
              over 80,000 copies sold and more than 2,000 reviews averaging 4.5
              stars. My mission is to demystify solar power and make it
              accessible to everyone. Join me in exploring the potential of
              solar power to create a cleaner, brighter future! Link to the book
              on Amazon. Read more about me here, check out my Youtube channel,
              or send me a message..
            </p>
          </div>
        </div>
      </div>
      <a
        href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-200"
      >
        <img
          src="/Assets/chat.png" // <-- Replace this with the actual image path or URL from Flaticon
          alt="WhatsApp Chat"
          className="w-8 h-8" // Tailwind sizes (e.g., w-6 = 24px)
        />
      </a>
      <Footer />
    </div>
  );
};

export default AffiliateDisclaimer;
